import type { FaireProductEntity } from "../../entity_types/product";

export const p_krsyynu9by: FaireProductEntity = {
  token: "p_krsyynu9by",
  type: "product",
  name: "Bauhaus Short Sleeve Sweater Tee - Peridot",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/ac7a65c03dd335d48b97a86243c6c82faac0edb1cd81e3f94f51201196dd2a0f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2fe7ca641a8438b599eae4f07b7fe35bcfe88f526e5e5a5ac2caa1fe9c741c86.jpeg",
    "https://cdn.faire.com/fastly/f4acefb3ce34e27854ace7c4898bb1f2ead3361de83ac3c59cb63a04622fa166.jpeg",
    "https://cdn.faire.com/fastly/6f2aa3322e3f18527482d260a3d3a0e54591556bf63560a3bc7947ffe86ee858.jpeg",
    "https://cdn.faire.com/fastly/f74049c347ffae620d2dd28e76dca42769007ad1442bb9ba93bbbd7447f5fcbc.jpeg",
    "https://cdn.faire.com/fastly/1794dd887067f56ec58ac2eed359c2200ab0717a8c6fe9c2c308d9aaf6c1e1e5.jpeg"
  ],
  priceDollars: 75.6,
  description: "Our signature Bauhaus Tee, built on a bold jacquard grid — the pattern is knitted in, never printed on top. Lightweight, breathable, and easy to style.\n\n * Slightly cropped and boxy body \n * 80% cotton, 20% modal \n * Made in Lima, Peru, with knitwear specialists we have worked with for years — Fair Trade certified ",
  tags: [],
  msrpDollars: 168,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:23.122Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
